module.exports = __webpack_public_path__ + "images/snp_smallf74847a720d16b11fb98fb6ea193f535.png";